import { isAxiosError } from 'axios';
import Personnummer from 'personnummer';

/** @deprecated - Use parseApiError instead */
export const isApiError = (error: unknown, { status, errorId }: { status?: number; errorId?: number }) =>
  isAxiosError<{ error: { errorId: number } }>(error) &&
  (status ? error.response?.status === status : true) &&
  (errorId ? error.response?.data.error?.errorId === errorId : true);

/**
 * Formats a national number to the YYYYMMDDBBBC format.
 * @param nationalNumber - The national number to format.
 * @returns The formatted national number, or null if the input is invalid.
 */
export const formatNationalNumber = (nationalNumber: string) => {
  try {
    return new Personnummer(nationalNumber).format(true);
  } catch {
    return null;
  }
};
